export enum GenericVars {
  SESSION_STORAGE_USERNAME = 'lxoSignupEmail'
}
